(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stt-advice"]) return;
  try {
    
  function sttPrefillAdvice(root) {
    const field = root.querySelector('[data-stt-product-prefill]');
    if (!field || field.value || field.hasAttribute('data-keep-value')) return;
    const product = new URLSearchParams(window.location.search).get('produkt');
    if (product) field.value = product.slice(0,250);
  }
  sttPrefillAdvice(document);
  document.addEventListener('shopify:section:load', event => sttPrefillAdvice(event.target));

  } catch(e) { console.error(e); }
})();
})();
